<div class="widget-content">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="title">{{ 'Upcoming Teams' | platformLabel }}</h2>
    <item-picker
      [data]="itemPickerValues"
      [selectedValue]="selectedItemPickerValue"
      (select)="itemPickerSelect($event)"
      [smallSize]="true"
    ></item-picker>
  </div>
  @if (loaded) {
    <div>
      @if (odataResult.length > 0) {
        <div>
          <div class="bars-container">
            @for (item of odataResult; track item) {
              <app-upcoming-teams-bar-chart
                [item]="item"
              ></app-upcoming-teams-bar-chart>
            }
          </div>
          <a mat-button class="view-all" (click)="goToUpcomingTeams()">{{
            'View All Upcoming Teams' | platformLabel
          }}</a>
        </div>
      }
      @if (odataResult.length == 0) {
        <div
          class="no-teams-content"
          fxLayout="column"
          fxLayoutAlign="center center"
        >
          <p>{{ 'You have no upcoming teams' | platformLabel }}</p>
          @if (isManager()) {
            <button mat-flat-button color="primary" (click)="addTeam.emit()">
              {{ 'Create a New Team' | platformLabel }}
            </button>
          }
          <a mat-button color="primary" (click)="goToTeams()"
            >View {{ 'All Active Teams' | platformLabel }}</a
          >
        </div>
      }
    </div>
  }
  @if (!loaded) {
    <div class="waiting-spinner">
      <mat-spinner strokeWidth="2" diameter="50"></mat-spinner>
      <p>Loading...</p>
    </div>
  }
</div>
